import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import { CLUSTER_ASSIGNMENT_OPTIONS_GROUP_ID } from '../constants'
import type { Plugin } from '../plugin'

/**
 * Clears the cluster options group when the assignment workflow ends.
 */
export const clearClusterAssignmentOptionsGroup = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    rxjs
      .merge(
        feature.actions.cancel.observe(),
        feature.actions.initiate.cancellation.observe(),
        feature.actions.submit.success.observe(),
        plugin.collection.feature.actions.changeContext.observe(),
      )
      .pipe(
        rxjs.map(action =>
          plugin.clustersEc.plugins.groupPlugin.feature.actions.delete
            .from(action)
            .create({
              groupId: CLUSTER_ASSIGNMENT_OPTIONS_GROUP_ID,
            }),
        ),
      ),
)
